import { Controller } from "@hotwired/stimulus"
import { setHidden } from "./sheet_steps_controller"

const NEW_CAMP = "new"

// The visit sheet's camp step: no camp, a nearby camp, or a new one named
// here. Picking a nearby camp prefills its status and counts so the worker
// edits what is on record instead of retyping it. Hidden fields are disabled
// so they do not post.
export default class extends Controller {
  static targets = ["select", "name", "details", "status", "structures", "people"]

  declare readonly selectTarget: HTMLSelectElement
  declare readonly nameTarget: HTMLElement
  declare readonly detailsTarget: HTMLElement
  declare readonly statusTarget: HTMLSelectElement
  declare readonly structuresTarget: HTMLInputElement
  declare readonly peopleTarget: HTMLInputElement

  connect() {
    this.toggle()
  }

  pick() {
    const option = this.selectTarget.selectedOptions[0]
    const camp = option?.dataset || {}
    this.statusTarget.value = camp.status || "occupied"
    this.structuresTarget.value = camp.structures || ""
    this.peopleTarget.value = camp.people || ""
    this.toggle()
  }

  private toggle() {
    const value = this.selectTarget.value
    this.show(this.nameTarget, value === NEW_CAMP)
    this.show(this.detailsTarget, value !== "")
  }

  private show(el: HTMLElement, on: boolean) {
    setHidden(el, !on)
    el.querySelectorAll<HTMLInputElement | HTMLSelectElement>("input, select").forEach((field) => { field.disabled = !on })
  }
}
